import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43fb59fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "purchases" }
const _hoisted_2 = { class: "top-bar" }
const _hoisted_3 = { class: "date" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "product-counts" }
const _hoisted_6 = { class: "product-count" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "product-count-label" }, "10-day", -1))
const _hoisted_8 = { class: "product-count" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "product-count-label" }, "Monthly", -1))
const _hoisted_10 = { class: "product-count" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "product-count-label" }, "Yearly", -1))
const _hoisted_12 = { class: "product-counts" }
const _hoisted_13 = { class: "product-count" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "product-count-label" }, "Users", -1))
const _hoisted_15 = { class: "product-count" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "product-count-label" }, "kr avg.", -1))
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "vertical-container" }
const _hoisted_19 = { class: "horizontal-container" }
const _hoisted_20 = { class: "chart" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "chart-title" }, "Purchases", -1))
const _hoisted_22 = { class: "chart" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "chart-title" }, "Proceeds", -1))
const _hoisted_24 = { class: "horizontal-container" }
const _hoisted_25 = { class: "chart" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "chart-title" }, "Yearly Proceeds", -1))
const _hoisted_27 = { class: "horizontal-container" }
const _hoisted_28 = { class: "chart" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "chart-title" }, "User Proceeds", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "user-spend-checkbox" }, "Include single 10-day", -1))
const _hoisted_31 = { class: "chart" }
const _hoisted_32 = { class: "chart-title-container" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "chart-title" }, "User Months", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "user-months-yearly-checkbox" }, "Include yearly", -1))
const _hoisted_35 = { class: "repeat-purchases-container" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Users with More than One Purchase:", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "renewals-checkbox" }, "Include renewals", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultipleChoiceToggle = _resolveComponent("MultipleChoiceToggle")!
  const _component_TimelineChart = _resolveComponent("TimelineChart")!
  const _component_HistogramChart = _resolveComponent("HistogramChart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "arrow-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dateDecr()))
        }, "◀"),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.date), 1),
        _createElementVNode("button", {
          class: "arrow-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dateIncr()))
        }, "▶")
      ]),
      (_ctx.purchases)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("h2", null, "Proceeds: " + _toDisplayString(Math.floor(_ctx.totalProceeds)) + "kr", 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.pass10Count), 1),
              _hoisted_7,
              _createTextVNode(" | "),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.subMonthCount), 1),
              _hoisted_9,
              _createTextVNode(" | "),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.subYearCount), 1),
              _hoisted_11
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.uniqueUserCount), 1),
              _hoisted_14,
              _createTextVNode(" | "),
              _createElementVNode("p", _hoisted_15, _toDisplayString(Math.floor(_ctx.totalProceeds / _ctx.uniqueUserCount)), 1),
              _hoisted_16
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, "Loading data...")),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_MultipleChoiceToggle, {
          class: "platform-toggle",
          options: _ctx.platformLabels,
          onSelected: _ctx.onPlatformSelected
        }, null, 8, ["options", "onSelected"]),
        _createVNode(_component_MultipleChoiceToggle, {
          class: "timeframe-toggle",
          options: _ctx.timeframeLabels,
          onSelected: _ctx.onTimeframeSelected
        }, null, 8, ["options", "onSelected"])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createVNode(_component_TimelineChart, {
            ref: "purchasesChart",
            interval: _ctx.timeframe,
            labels: _ctx.purchaseTypes,
            endDate: _ctx.endDate,
            colors: _ctx.purchaseColors
          }, null, 8, ["interval", "labels", "endDate", "colors"])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode(_component_TimelineChart, {
            ref: "revenueChart",
            interval: _ctx.timeframe,
            labels: _ctx.purchaseTypes,
            endDate: _ctx.endDate,
            colors: _ctx.purchaseColors
          }, null, 8, ["interval", "labels", "endDate", "colors"])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createVNode(_component_TimelineChart, {
            ref: "yearlyRevenueChart",
            interval: _ctx.timeframe,
            labels: _ctx.purchaseTypes,
            endDate: _ctx.endDate,
            colors: _ctx.purchaseColors
          }, null, 8, ["interval", "labels", "endDate", "colors"])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createVNode(_component_HistogramChart, {
            ref: "userSpendChart",
            interval: 20,
            start: 0,
            tags: ['Active', 'Inactive']
          }, null, 512),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "user-spend-checkbox",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userSpendIncludeSingle10Day) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.userSpendIncludeSingle10Day]
            ]),
            _hoisted_30
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("button", {
              class: "chart-export-button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copyMonthyRetention()))
            }, "Export")
          ]),
          _createVNode(_component_HistogramChart, {
            ref: "userMonthsChart",
            tags: ['Cumulative', 'Current', 'Inactive'],
            colors: [_ctx.purchaseColors[0], _ctx.purchaseColors[1], _ctx.purchaseColors[2]]
          }, null, 8, ["colors"]),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "user-months-yearly-checkbox",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userMonthsIncludeYearly) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.userMonthsIncludeYearly]
            ]),
            _hoisted_34
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _hoisted_36,
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "renewals-checkbox",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.multiplePurchaseIncludeRenewals) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.multiplePurchaseIncludeRenewals]
          ]),
          _hoisted_37
        ]),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMultiPurchaseUsers(), (user) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: user.userId
            }, [
              _createElementVNode("h3", null, _toDisplayString(user.userId), 1),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.purchases, (purchase) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: purchase.timestamp
                  }, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.formatDate(new Date(purchase.timestamp), 'hour')) + ": " + _toDisplayString(purchase.productId) + " " + _toDisplayString(purchase.isRenewal ? "(renewal)" : ""), 1)
                  ]))
                }), 128))
              ])
            ], 64))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", null, " Invalid purchases " + _toDisplayString(_ctx.invalidPurchases), 1)
  ], 64))
}